import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import { useClickOutsideAlerter } from "../../../../hooks/useClickOutsideAlerter";
import style from "./DatePicker.module.scss";
export const DatePicker: React.FC<{
  selected?: number;
  onChange: (selected: number) => void;
  onClickOutside?: () => void;
  className?: string;
  lastDayOfMonthOption: boolean;
  lastDayOfMonthLabel?: string;
}> = t0 => {
  const $ = _c(15);
  const {
    selected,
    onChange,
    onClickOutside,
    className,
    lastDayOfMonthOption,
    lastDayOfMonthLabel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const dates = t1;
  const datepickerContainerRef = useRef(null);
  useClickOutsideAlerter(datepickerContainerRef, onClickOutside ? onClickOutside : _temp);
  let t2;
  if ($[1] !== className) {
    t2 = [style["datepicker-wrapper"], className];
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = t2.join(" ");
  let t4;
  if ($[3] !== onChange || $[4] !== selected) {
    t4 = dates.map(date => <button key={date} tabIndex={0} onClick={e => {
      e.currentTarget.blur();
      onChange(date);
    }} className={style["datepicker-button"] + " " + (selected === date ? style["datepicker-button--selected"] : "")} data-cy={`date-picker-button-${date}`}>{date}</button>);
    $[3] = onChange;
    $[4] = selected;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== lastDayOfMonthLabel || $[7] !== lastDayOfMonthOption || $[8] !== onChange || $[9] !== selected) {
    t5 = lastDayOfMonthOption && <div className={style["datepicker-last-row"]}><button tabIndex={0} className={style["datepicker-button-last"] + " " + (selected === 0 ? style["datepicker-button-last--selected"] : "")} onClick={e_0 => {
        e_0.currentTarget.blur();
        onChange(0);
      }} data-cy="date-picker-button-last">{lastDayOfMonthLabel}</button></div>;
    $[6] = lastDayOfMonthLabel;
    $[7] = lastDayOfMonthOption;
    $[8] = onChange;
    $[9] = selected;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className={t3} ref={datepickerContainerRef} data-cy="date-picker">{t4}{t5}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp() {}